<div class="dropdown-wrapper" (mouseleave)="showDropDown = false">

  <!-- Toggle Button -->
  <button class="drop-toggle btn btn-light w-100 text-start" (click)="toggleDropdown()">

    <span>{{ getSelectedText() }}</span>
    <i class="fa fa-angle-down float-end"></i>

  </button>

  <!-- Dropdown -->
  @if (showDropDown) {
  <div class="drop-show border p-2 bg-white">

    @for (a of list; track a.name) {
    <label class="d-flex align-items-center gap-2 py-1">

      <input type="checkbox" [(ngModel)]="a.checked" (change)="onChange()" />

      <span>{{ a.name }}</span>

    </label>
    }

  </div>
  }

</div>
